<template>
	<div class="text-center">
		<div class="inline-flex">
			<vx-tooltip :text="'Edit'" position="bottom" class="cursor-pointer mr-5">
				<feather-icon icon="Edit2Icon" :svgClasses="`h-4 w-4`" @click="editPromoRequest()"/>
			</vx-tooltip>
		</div>
		<!-- <div class="inline-flex">
			<vx-tooltip :text="'Duplicate'" position="bottom" class="cursor-pointer">
			   <feather-icon icon="CopyIcon" :svgClasses="`h-4 w-4`" @click="duplicateMISRecord()"/>
			</vx-tooltip>
		</div>	 -->
	</div>
	
</template>

<script>
	
	 export default {
	 	name: 'CellRendererMISSuggestionActions',	 
		data() {
			return {  				 
			}
		},
        computed: {           
		},
		methods: {
			editPromoRequest(){
				// console.log(this.params.node.parent);
				var rowData = this.params;
				this.$root.$emit('editPromoRequest', rowData);
			},
			duplicateMISRecord(){
				// console.log(this.params.node.parent);
				//console.log(this.params.data);
				var rowData = this.params;
				this.$root.$emit('duplicateMISRecord', rowData);
			},			
		 },
	}
</script>
<style lang="scss">
    .disabled{
		pointer-events: none;
        opacity: 0.4;
	}
</style>